import { memo, useMemo } from 'react';
import { Marker } from '@adamscybot/react-leaflet-component-marker';
import { MapPointIcon } from '@icons';
import { RouteMarkerType } from '@lp/features/RoutePlanner/types';

export const CustomLocationRouteMarker = memo(({ location }: RouteMarkerType) => {
  const icon = useMemo(
    () => (
      <div className="relative flex flex-col justify-center items-center -translate-y-1/3">
        <div className="relative mt-0.5 text-base-25 overflow-hidden">
          <MapPointIcon />
        </div>
        <div className="box-border w-3 h-3 rounded-full border-3 bg-white border-base-25" />
      </div>
    ),
    [],
  );

  return (
    <Marker
      position={location}
      zIndexOffset={10}
      componentIconOpts={{
        disableClickPropagation: true,
      }}
      icon={icon}
    />
  );
});
